import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
    imageContainer: ({ height, width }) => {
        const aspectRatio = (height / width) * 100
        return {
            paddingBottom: `${aspectRatio}%`,
            position: 'relative',
            overflow: 'hidden',
            background: 'rgba(0, 0, 0, 0.05)',
            display: 'block',
        }
    },

    image: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',

        '&.has-error': {
            filter: 'none',
            transform: 'scale(1)',
        },
    },

    thumb: ({ isLoaded }) => ({
        visibility: isLoaded ? 'hidden' : 'visible',
        filter: 'blur(20px)',
        transform: 'scale(1.1)',
        transition: 'visibility 0ms ease 400ms',
    }),

    full: ({ isLoaded }) => ({
        opacity: isLoaded ? 1 : 0,
        transition: 'opacity 400ms ease 0ms',
    }),
}))
